import { render } from "./TipoContrato.vue?vue&type=template&id=30beea30"
import script from "./TipoContrato.vue?vue&type=script&lang=js"
export * from "./TipoContrato.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__